<template>
  <div>
    <Navbar/>
    <h4>Examen Físico</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idExamenFisico" class="form-label">IdExamenFisico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamenFisico" name="idExamenFisico" v-model="datoExamenFisico.idExamenFisico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoExamenFisico.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Codigo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoExamenFisico.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamenFisico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamenFisico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdExamOpcion</th>
          <th scope="col">IdExamenFisico</th>
          <th scope="col">Nombre</th>
          <th scope="col">Tipo</th>
          <th scope="col">Estado</th>
          <th scope="col">ExamenFisicoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="examopcion in datosPaginados" :key="examopcion.idExamOpcion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(examopcion.idExamOpcion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(examopcion.idExamOpcion)" title="Editar">edit_square</i></td>
          <td>{{examopcion.idExamOpcion}}</td>
          <td>{{examopcion.idExamenFisico}}</td>
          <td>{{examopcion.nombre}}</td>
          <td>{{examopcion.tipo}}</td>
          <td>{{examopcion.estado}}</td>
          <td>{{examopcion.examenFisicoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteExamenFisico(examopcion.idExamOpcion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idExamOpcion" class="form-label">IdExamOpcion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamOpcion" name="idExamOpcion" v-model="datoExamOpcion.idExamOpcion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idExamenFisico" class="form-label">IdExamenFisico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExamenFisico" name="idExamenFisico" v-model="datoExamOpcion.idExamenFisico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoExamOpcion.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoExamOpcion.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarExamOpcion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExamOpcion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      examenfisicos : [],
      datoExamenFisico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idExamenFisico: '',
// Variables master
// Variables details
      examopcions : [],
      datoExamOpcion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      examenFisicos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idExamenFisico = this.$route.params.p_idexamenfisico
    this.abrirEditar(this.p_idExamenFisico)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'codigo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'codigo'
      ];
      return validarForm(this.datoExamenFisico, requiredFields, requiredFieldsText);
    },
    async guardarExamenFisico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examenfisicos', this.datoExamenFisico)
          swal("Correcto!", "ExamenFisico creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamenFisico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examenfisicos', this.datoExamenFisico)
          swal("Correcto!", "ExamenFisico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoExamenFisico={}
      this.titulo   = 'Crear Examen Físico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idExamenFisico){
      this.modalWindow = true
      if(idExamenFisico != null){    
           api.get('/vwexamenfisicos/'+idExamenFisico).then(resp=>{
          this.datoExamenFisico = resp.data;
           });
      }
      this.titulo   = 'Editar Examen Físico'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarExamenFisico(){
      this.$router.push('/ExamenFisico')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.examopcions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwexamopcions/nombre/'+this.nombreBusqueda).then(response=>{
          this.examopcions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.examopcions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwexamopcions').then(response=>{
      this.examopcions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.examopcions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
        ,'codigo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'codigo'
      ];
      return validarForm(this.datoExamenFisico, requiredFields, requiredFieldsText);
    },
    async guardarExamOpcion(){
      if(this.validarForm() === 1){
        try {
          this.datoExamOpcion.idExamenFisico = this.datoExamenFisico.idExamenFisico;
          await api.post('/examopcions', this.datoExamOpcion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ExamOpcion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExamOpcion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/examopcions', this.datoExamOpcion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ExamOpcion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoExamOpcion={}
      this.titulo   = 'Crear Examen Físico'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idExamOpcion){
      this.modalWindow = true
      if(idExamOpcion != null){    
           api.get('/vwexamopcions/'+idExamOpcion).then(resp=>{
          this.datoExamOpcion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Examen Físico'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idExamOpcion){
      this.modalWindow = true
      if(idExamOpcion != null){
        this.$router.push('/examopcionmd/'+idExamOpcion)
      }
    },
    async deleteExamOpcion (idExamOpcion) {
      try{
        await api.delete('/examopcions/'+idExamOpcion)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchExamenFisicos() {
      fetch('http://localhost:8080/api/v1/examenfisicos')
        .then(response => response.json())
        .then(data => {
          this.examenFisicos = data;
        })
        .catch(error => {
          console.error('Error fetching examenFisicos:', error);
        });
    },
  },
}
</script>
